export default __webpack_public_path__ + "static/nurse-sad-8ed61ea45a4d1806700b756a878cff18.png";